import instance from '@src/api/common';
import { parseMetricPayload } from '@src/emp-3.0/utils/metrics';

export const requestMetricList = () => {
  return instance.get(`/v1/metrics`);
};

export const requestMetric = (id) => {
  return instance.get(`/v1/metrics/${id}`);
};

export const requestDeleteMetric = (metricId: string | number) => {
  return instance.delete(`/v1/metrics/${metricId}`);
};

export const postCreateMetric = (queryBody) => {
  const payload = parseMetricPayload(queryBody);
  return instance.post(`/v1/metrics`, payload);
};

export const putUpdateMetric = (id, queryBody) => {
  const payload = parseMetricPayload(queryBody);
  return instance.put(`/v1/metrics/${id}`, payload);
};

export const requestDeleteVersion = (queryBody, type) => {
  return instance.post(`/v1/delete_version/${type}`, { detail_ids: queryBody });
};

export function postActivateMetric(payload) {
  const data = parseMetricPayload(payload);
  return instance.post(`/v1/metrics/activate`, data);
}
export function putActivateMetric(metric_id, payload) {
  const data = parseMetricPayload(payload);
  return instance.put(`/v1/metrics/${metric_id}/activate`, data);
}
